<script setup lang="ts">
import { ref, watch } from 'vue';
import { Printer, IconChange } from '@xpos/icons-svg';
import { usePrinterStore } from '@/stores/printer';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const printerStore = usePrinterStore();
const $props = defineProps<{
  modelValue: boolean;
}>();

const $emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void;
  (event: 'close'): void;
  (event: 'select', ip: string): void;
}>();

const printers = ref<string[]>([]);
const scaning = ref(false);
const visible = ref($props.modelValue);
const selectItem = (ip: string) => {
  $emit('select', ip);
};

const scanPrint = () => {
  scaning.value = true;

  printerStore
    .searchPrinters()
    .then((list?: string[]) => {
      if (list) {
        printers.value = list;
      }

      scaning.value = false;
    })
    .catch(() => {
      scaning.value = false;
    });
};

const handleClose = () => {
  $emit('close');
};
watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = newVal;
  },
);
</script>

<template>
  <x-dialog
    v-model="visible"
    width="770px"
    :title="t('setup.printers.printerList')"
    :close-on-click-modal="false"
    :modal="false"
    @close="handleClose"
  >
    <div class="flex flex-col w-full" v-loading="scaning">
      <div class="grow">
        <div class="mb-1">{{ t('setup.printers.ipAddress') }}</div>
        <div class="flex gap-[5px]">
          <div v-for="item in printers">
            <x-button square size="large" color="#52599D" @click="selectItem(item)">
              <el-icon size="40">
                <Printer />
              </el-icon>
              <template #footer>
                <div class="text-center w-full">
                  {{ item }}
                </div>
              </template>
            </x-button>
          </div>
        </div>
      </div>
      <div>
        <el-button type="primary" @click="scanPrint">
          <el-icon size="20" class="align-sub"><IconChange /></el-icon>
          {{ t('setup.printers.scan') }}
        </el-button>
      </div>
    </div>
  </x-dialog>
</template>
